var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Profile page",
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1100,
    transform: "translate(-1301 -191)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004382",
    filter: "url(#filter0_d_0_1)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -975,
    y: -175,
    width: 1128,
    height: 1084,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000004422"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -928.5,
    y: -44.5,
    width: 1018,
    height: 135,
    rx: 7.5,
    stroke: "#DCDBDD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame 260"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -17.5,
    y: -11.5,
    width: 79,
    height: 39,
    rx: 3.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -17.5,
    y: -11.5,
    width: 79,
    height: 39,
    rx: 3.5,
    stroke: "#DCDBDD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_2",
    d: "M3.83333 12.6667H4.78333L11.3 6.15L10.35 5.2L3.83333 11.7167V12.6667ZM3.16667 14C2.97778 14 2.81944 13.9361 2.69167 13.8083C2.56389 13.6806 2.5 13.5222 2.5 13.3333V11.7167C2.5 11.5389 2.53333 11.3694 2.6 11.2083C2.66667 11.0472 2.76111 10.9056 2.88333 10.7833L11.3 2.38333C11.4333 2.26111 11.5806 2.16667 11.7417 2.1C11.9028 2.03333 12.0722 2 12.25 2C12.4278 2 12.6 2.03333 12.7667 2.1C12.9333 2.16667 13.0778 2.26667 13.2 2.4L14.1167 3.33333C14.25 3.45556 14.3472 3.6 14.4083 3.76667C14.4694 3.93333 14.5 4.1 14.5 4.26667C14.5 4.44444 14.4694 4.61389 14.4083 4.775C14.3472 4.93611 14.25 5.08333 14.1167 5.21667L5.71667 13.6167C5.59444 13.7389 5.45278 13.8333 5.29167 13.9C5.13056 13.9667 4.96111 14 4.78333 14H3.16667ZM10.8167 5.68333L10.35 5.2L11.3 6.15L10.8167 5.68333Z",
    fill: "#696974"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: -979,
    y: -175,
    width: 1136,
    height: 1092,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1100,
    fill: "white",
    transform: "translate(-1301 -191)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.80c5bc8180b5279ed3370391b40382ca.svg";
export { ForwardRef as ReactComponent };